import { RenderElementProps } from 'slate-react';

export const FAQ = 'FAQ';
export const FAQ_SENTENCES = 'FAQ_SENTENCES';
export const FAQ_QUESTION = 'FAQ_QUESTION';
export const FAQ_ANSWER = 'FAQ_ANSWER';
export const FAQ_SENTENCE = 'FAQ_SENTENCE';

export type FaqPluginOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type FaqProps = FaqPluginOptions & RenderElementProps;
